import { Paper, SimpleGrid, Text, Title } from "@mantine/core";
import { useCustomerInsuranceStore } from "../../hooks/ui/customerInsuranceStore";
import InsurancesPartyList from "../insurancePartyList";
import { v4 as uuidV4 } from "uuid";

function detectStatus(status: string) {
  switch (status) {
    case "F":
      return "Fribrev";
    case "G":
      return "Gällande";
    default:
      return "Okänd";
  }
}
const InsuranceDetails = () => {
  const data = useCustomerInsuranceStore.getState()?.insurance;

  return data ? (
    <Paper p={{ base: "lg", sm: "xl" }} radius={"lg"} mb={"xl"}>
      <Title order={4} mb={"lg"} ff={"var(--wallet-font-family-sambla-sans)"}>
        Grunduppgifter
      </Title>
      <SimpleGrid
        cols={{ base: 2, sm: 4 }}
        spacing={{ base: "md", sm: "lg" }}
        mt="xl"
        mb={"lg"}
      >
        <Text>
          <strong>Försäkringsbolag:</strong>
        </Text>
        <Text>{data?.insuranceCompany?.name}</Text>
        <Text>
          <strong>Status:</strong>
        </Text>
        <Text>{detectStatus(data?.status)}</Text>
        <Text>
          <strong>Pensionsålder:</strong>
        </Text>
        <Text>{data?.zAge} år</Text>
        <Text>
          <strong>Pensionsdatum:</strong>
        </Text>
        <Text>{new Date(data?.zDate).toLocaleDateString("sv-SE")}</Text>
      </SimpleGrid>

      <Text mb={"sm"}>
        <strong>Parter:</strong>
      </Text>
      {data.parties &&
        data.parties.map((party) => (
          <InsurancesPartyList key={uuidV4()} party={party} />
        ))}
    </Paper>
  ) : null;
};

export default InsuranceDetails;
